// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"agent_emailAddress":{"b":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function accountMemberRole_decode($$enum) {
  if ($$enum === "ASSISTANT" || $$enum === "UNKNOWN" || $$enum === "ASSOCIATE" || $$enum === "TRANSACTION_COORDINATOR" || $$enum === "BUYER_SPECIALIST" || $$enum === "SHOWING_ASSISTANT" || $$enum === "CLIENT_CARE_COORDINATOR" || $$enum === "PARTNER" || $$enum === "INSIDE_SALES_AGENT" || $$enum === "OWNER" || $$enum === "LISTING_MANAGER" || $$enum === "OPERATIONS_MANAGER" || $$enum === "LISTING_SPECIALIST" || $$enum === "MARKETING_SPECIALIST") {
    return $$enum;
  }
}

let accountMemberRole_fromString = accountMemberRole_decode;

let Utils = {
  accountMemberRole_decode: accountMemberRole_decode,
  accountMemberRole_fromString: accountMemberRole_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SubuserMemberEditForm_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "Agent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "AccountMember",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
